// 尺寸454*320
import React from 'react'
import ReprintPage from '@/pages/AndroidDevice/reprint/print'
const ReprintSCPage = () => {
  return <ReprintPage reprintType="sc"></ReprintPage>
}
export default ReprintSCPage
